throw new Error(
  "The `emotion` package has been renamed to `@emotion/css`. Please import it like this `import { css } from '@emotion/css'`."
)
